export enum LanguagesEnum {
  PL = 'pl',
  EN = 'en',
  DE = 'de'
}
